import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ButtonIconSet, ButtonIconType } from '../buttons.types';

@Component({
  selector: 'common-buttons-filled',
  templateUrl: './buttons-filled.component.html',
  styleUrls: ['./buttons-filled.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ButtonsFilledComponent implements OnInit {
  private readonly defaultIconSet = 'material-symbols-rounded';

  @Input() label: string;
  @Input() icon: string;
  @Input() disabled: boolean = false;
  @Input() typeIcon: ButtonIconType = 'outlined'
  @Input() iconSet: ButtonIconSet;
  @Input() iconPosition: boolean = true;

  @Output() output: EventEmitter<boolean> = new EventEmitter<boolean>();


  constructor() { }

  ngOnInit(): void { }

  get iconClass(): string {
    if (this.iconSet) {
      return this.iconSet;
    }

    if (this.typeIcon === 'outlined') {
      return 'material-icons-outlined';
    }

    if (this.typeIcon === 'rounde') {
      return 'material-symbols-rounded';
    }

    return this.defaultIconSet;
  }

  onClick() {
    this.output.emit(true);
  }
}
